/** Captured from Clients List Print Settings modal. */
export const LIST_PRINT_SETTINGS = {
  "dccId": "129",
  "fpsId": "89",
  "sortingBy": "cli_dcc_status",
  "sortingByOptions": [
    {
      "value": "",
      "label": "Select Sorting By"
    },
    {
      "value": "cli_name",
      "label": "Client Name"
    },
    {
      "value": "cli_adm_date",
      "label": "Admission Date"
    },
    {
      "value": "cli_email",
      "label": "Email"
    },
    {
      "value": "cli_dcc_status",
      "label": "DCC Status"
    }
  ],
  "sortingType": "ASC",
  "sortingTypeOptions": [
    {
      "value": "ASC",
      "label": "Ascending"
    },
    {
      "value": "DESC",
      "label": "Descending"
    }
  ],
  "pageSetup": "A4",
  "pageSetupOptions": [
    {
      "value": "A4",
      "label": "A4"
    },
    {
      "value": "A11",
      "label": "A11"
    },
    {
      "value": "A3",
      "label": "A3"
    }
  ],
  "orientation": "Portrait",
  "orientationOptions": [
    {
      "value": "Landscape",
      "label": "Landscape"
    },
    {
      "value": "Portrait",
      "label": "Portrait"
    }
  ],
  "hfRequired": false,
  "isCenterLogo": true,
  "logoName": "1711106396_12c235746608ac0b4a22.jpg",
  "header": "",
  "footer": "",
  "rows": [
    {
      "id": "28063",
      "label": "Client Name",
      "priority": "1",
      "checked": true
    },
    {
      "id": "28064",
      "label": "Client Picture",
      "priority": "2",
      "checked": true
    },
    {
      "id": "28065",
      "label": "Admission Date",
      "priority": "3",
      "checked": false
    },
    {
      "id": "28066",
      "label": "Payer Name",
      "priority": "4",
      "checked": false
    },
    {
      "id": "28067",
      "label": "Contact Number",
      "priority": "5",
      "checked": true
    },
    {
      "id": "28068",
      "label": "Email",
      "priority": "6",
      "checked": false
    },
    {
      "id": "28069",
      "label": "Status",
      "priority": "7",
      "checked": true
    },
    {
      "id": "28070",
      "label": "LOC",
      "priority": "8",
      "checked": true
    },
    {
      "id": "28071",
      "label": "Care Manager",
      "priority": "9",
      "checked": true
    },
    {
      "id": "29665",
      "label": "Transportation Broker",
      "priority": "10",
      "checked": false
    },
    {
      "id": "36424",
      "label": "Mobility ID Number",
      "priority": "11",
      "checked": false
    },
    {
      "id": "40238",
      "label": "Client ID",
      "priority": "12",
      "checked": false
    },
    {
      "id": "41445",
      "label": "Date of Birth",
      "priority": "13",
      "checked": false
    }
  ]
} as const
